module.exports = __webpack_public_path__ + "static/media/8OLA12.4310d57a.jpg";